/* eslint-disable no-unused-expressions */
import React from "react";
import "./CreatePostControlInfo.scss";
import * as actions from "../../Redux/Actions/Controls";
import { connect } from "react-redux";
import { store } from "../../Redux/Store/Store";
import * as actionsFindingKinds from "../../Redux/Actions/FindingKinds";
import * as PropertyBucket from "../../Properties/Properties";
import { ControlDetailInfo } from "../ControlDetailInfo/ControlDetailInfo";
import { CreatePostControlInfoAttachments } from "../CreatePostControlInfoAttachments/CreatePostControlInfoAttachments";
import CreatePostControlInfoFindings from "../CreatePostControlInfoFindings/CreatePostControlInfoFindings";
import CreatePostControlInfoCorrections from "../CreatePostControlInfoCorrections/CreatePostControlInfoCorrections";
import {
  mapControlBlockOccurance,
  mapNewAttachmentsForPostControlInfo,
  mapPaymentClaims,
  serializeAttachmentsForPostControlInfoSaving,
  serializeInitialAttachmentsForForm,
} from "../documents/helpers";
import * as httpService from "../HttpService/HttpService";
import { FindingDto } from "../Dtos/FindingDto";
import { BlockInListDto } from "../Dtos/BlockInListDto";
import { Waiter } from ".././WaitingSign/Waiting";
import PopUp from ".././PopUp/PopUp";
import { ChooseBlock } from "../ChooseBlock/ChooseBlock";
import { Prompt } from "react-router-dom";
import { generatePostControllInfoDocx } from "../DocxTemplate/PostControlInfoDocx";
import { isWTrakcieRealizacji, isZrealizowana, getUniqueBlocks } from "../ControlStateHelper";
import { createPdf } from "../PostControlInfoDetail/PostControlInfoDetail";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { sendLog } from "../HttpService/SendLog";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { AuditDetail } from "../AuditDetail/AuditDetail";
import WysiwygEditor from "../WysiwygEditor/WysiwygEditor";
import Input from "../Input/Input";
import { orderBy, cloneDeep } from "lodash";
import { draftjsToString } from "../WysiwygEditor/WysiwygHelpers";
import { convertFromRaw } from 'draft-js';

class CreatePostControlInfo extends React.Component {
  infoId;
  controlId;

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      popUp: { title: null, notification: null },
      controlData: null,
      checklistVersion: "Wersja 1",
      infoData: null,
      originalInfoData: null,
      postControlDocumentId: null,
      infoDataSource: null,
      abbrevs: "", // przechowuje wykaz skrótów jako string
      originalAbbrevs: "",
      findings: [],
      originalFindings: [], //store copy of findings for corrections edit
      findingsSource: [],
      chosenBlockToCreateNewFinding: null,
      abrInputAutofocus: false,
      findingInputautofocus: false,
      isEmptyField: false,
      attachments: [],
      originalAttachments: [],
      isChangeRoutePossible: true,
      isPreventPromptEnabled: true,
      sectionUnderEdit: null,
      findingUnderEdit: null,
      originalFinding: null,
      originalChecklistVersion: null,
      financialFindingsNotes: "",
      originalFinancialFindingsNotes: "",
    };
    this.handleClosePopUp = this.handleClosePopUp.bind(this);
  }

  isSectionEdit(sectionName) {
    return (
      this.state.sectionUnderEdit === sectionName &&
      this.state.findingUnderEdit === null
    );
  }

  getSectionUrl(sectionName) {
    switch (sectionName) {
      case "legalBasis":
        return PropertyBucket.setLegalBasis(this.infoId);
      case "controlPurpose":
        return PropertyBucket.setControlPurpose(this.infoId);
      case "controlSubject":
        return PropertyBucket.setControlSubject(this.infoId);
      case "controlSummary":
        return PropertyBucket.setControlSummary(this.infoId);
      case "finalInstructions":
        return PropertyBucket.setFinalInstructions(this.infoId);
    }
  }

  isDataChanged() {
    const infoDataJSON = JSON.stringify(this.state.infoData).replace(
      /\:null/gi,
      ':""'
    );
    const infoDatasourceJSON = JSON.stringify(
      this.state.infoDataSource
    ).replace(/\:null/gi, ':""');

    if (infoDataJSON !== infoDatasourceJSON) {
      return true;
    }

    const findingsJSON = JSON.stringify(this.state.findings).replace(
      /\:null/gi,
      ':""'
    );
    const findingsSourceJSON = JSON.stringify(
      this.state.findingsSource
    ).replace(/\:null/gi, ':""');

    if (findingsJSON !== findingsSourceJSON) {
      return true;
    }

    return false;
  }

  componentDidMount() {
    const { fetchFindingKindsData } = this.props;
    fetchFindingKindsData();
    if (this.props.match.params.infoId) {
      this.infoId = this.props.match.params.infoId;
      this.controlId = this.props.match.params.controlId;
      this.fetchInfoData(this.controlId);
    }
  }

  componentDidUpdate() {
    const isDataChanged = this.isDataChanged();

    if (isDataChanged && this.state.isChangeRoutePossible) {
      this.setState({ isChangeRoutePossible: false });
    } else if (!isDataChanged && !this.state.isChangeRoutePossible) {
      this.setState({ isChangeRoutePossible: true });
    }

    if (this.isNotEditableNotFinalInfo()) {
      this.props.history.replace(
        "/my_controls/" +
          this.controlId +
          "/post_control_info_detail/" +
          this.infoId
      );
    }
  }

  isNotEditableNotFinalInfo() {
    const controlData = this.state.controlData;
    return (
      controlData &&
      (this.isDoneStatus(controlData) || this.isFinalDate(controlData))
    );
  }

  isDoneStatus = (infoData) => {
    return isZrealizowana(infoData);
  };
  isFinalDate = (infoData) => {
    const docINF = infoData?.postControlDocuments.find(
      (el) => el.postControlInfo && !el.postControlInfo.isFinalInfo
    );
    return docINF?.postControlInfo?.finalInfoSendDate;
  };

  fetchInfoData = (controlId) => {
    let url = PropertyBucket.getMyControlDetailByControlId(this.controlId);
    let response = httpService.getService(url, "GET");
    response
      .then((data) => {
        let postControlDocument = data.postControlDocuments.find(
          (el) => el.postControlInfo && el.postControlInfo.id == this.infoId
        ).postControlInfo;
        let postControlDocumentId = data.postControlDocuments.find(
          (el) => el.postControlInfo && el.postControlInfo.id == this.infoId
        ).id;
        let attachmentsMap = mapNewAttachmentsForPostControlInfo(
          postControlDocument,
          data
        );
        const findingsData = JSON.parse(
          JSON.stringify(postControlDocument.findings)
        );
        findingsData.sort(
          (firstEl, secondEl) => firstEl.findingId - secondEl.findingId
        );

        let blockOccuranceMap = mapControlBlockOccurance(data);
        findingsData.forEach((f) => {
          f.blockInList = blockOccuranceMap.get(f.blockInList.referenceId);
        });
        mapPaymentClaims(data, findingsData);

        this.setState({
          controlData: data,
          checklistVersion: postControlDocument.checklistVersion || "Wersja 1",
          postControlDocumentId: postControlDocumentId,
          infoData: postControlDocument,
          infoDataSource: postControlDocument,
          abbrevs: postControlDocument.abbreviations || "",
          findings: findingsData,
          findingsSource: findingsData,
          attachments: serializeInitialAttachmentsForForm(attachmentsMap || []),
          financialFindingsNotes: postControlDocument.financialFindingsNotes || "",
          isWaiting: false,
        });
      })
      .catch((error) => {
        this.setState({
          showPopup: true,
          popUp: { title: "Błąd", notification: error.message, type: "error" },
          isWaiting: false,
        });
      });
  };

  handleAllFindingsRefresh = (findings) => {
    let currentFindings = this.state.findings.filter(
      (finding) =>
        finding.isFinancial === false ||
        (finding.isFinancial === true && finding.findingKind === null)
    );
    let newFindings = [...currentFindings, ...findings];
    this.setState({
      findings: newFindings,
    });
  };

  handleFindingsRefresh = (findings, blockId) => {
    let currentFindings = this.state.findings.filter(
      (finding) => finding.blockInList.id !== blockId
    );
    let newFindings = [...currentFindings, ...findings];

    let withId = newFindings.filter((item) => item.id !== undefined);
    let withPseudoId = newFindings.filter(
      (item) => item.pseudoId !== undefined
    );

    // Sort each part individually
    withId = orderBy(withId, ["id"], ["asc"]);
    withPseudoId = orderBy(withPseudoId, ["pseudoId"], ["asc"]);

    // Combine the sorted arrays
    let sortedFindings = [...withId, ...withPseudoId];

    this.setState({
      findings: sortedFindings,
    });
  };

  handleSaveFinding = (findingId, findingPseudoId) => {
    const isNewFinding = findingId == null;
    const finding = this.state.findings.find((x) =>
      isNewFinding ? x.pseudoId === findingPseudoId : x.id === findingId
    );

    if (!this.handleValidateFindings([finding])) {
      this.showPopup("Błąd", "Uzupełnij wszystkie pola ustalenia", "error");
      return;
    }

    this.setState({ findingUnderEdit: null });
    this.isWaitingOnOff(true);

    const url = isNewFinding
      ? PropertyBucket.addFinding(this.infoId)
      : PropertyBucket.updateFinding(this.infoId, findingId);

    const { blockInList, findingKind, corrections, ...rest } = finding;

    const payload = {
      ...rest,
      blockInListId: blockInList?.id,
      findingTypeId: findingKind?.id,
    };

    const method = isNewFinding ? "POST" : "PUT";
    const callPromise = httpService.getServicePromise(url, method, payload);

    callPromise.then(
      (response) => {
        if (isNewFinding) {
          this.setState({
            findings: this.state.findings.map((finding) => {
              if (finding.pseudoId === findingPseudoId) {
                finding.id = response.id;
                finding.pseudoId = undefined;
              }
              return finding;
            }),
          });
        }

        this.isWaitingOnOff(false);
        this.showPopup("Komunikat", "Poprawnie zapisano ustalenie");
        this.setState({
          infoData: {
            ...this.state.infoData,
            isValidated: false,
          },
        });
        this.fetchInfoData(this.infoId);
      },
      (error) => {
        this.isWaitingOnOff(false);
        this.showPopup("Błąd", error.message || error, "error");
      }
    );
  };

  handleDeleteFinding = (findingId) => {
    this.isWaitingOnOff(true);

    const url = PropertyBucket.deleteFinding(this.infoId, findingId);

    const callPromise = httpService.getServicePromise(url, "DELETE");

    callPromise.then(
      () => {
        this.isWaitingOnOff(false);
        this.showPopup("Komunikat", "Poprawnie usunięto ustalenie");
        this.fetchInfoData(this.infoId);
      },
      (error) => {
        this.isWaitingOnOff(false);
        this.showPopup("Błąd", error.message || error, "error");
      }
    );
  };

  handleClosePopUp() {
    this.setState({ showPopup: false });
  }

  showPopup = (title, notification, type, onClickEvent, link) => {
    this.setState({
      showPopup: true,
      popUp: {
        title: title,
        notification: notification,
        type: type,
        onClickEvent: onClickEvent,
        link: link,
      },
    });
  };

  preventChangeRoute = (newLocation) => {
    this.setState({
      showPopup: true,
      popUp: {
        title: "Ostrzeżenie",
        notification: PropertyBucket.getCancelMessage(),
        type: "cancel",
        newLocationLink: newLocation,
        onClickEvent: this.changeRoute,
      },
      isPreventPromptEnabled: false,
    });

    return false;
  };

  changeRoute = () => {
    this.setState({
      isPreventPromptEnabled: false,
    });

    this.state.popUp.newLocationLink &&
      this.props.history.push(this.state.popUp.newLocationLink);
  };

  handleChange = (e) => {
    let infoData = {
      ...this.state.infoData,
      [e.target.name]: e.target.value,
    };
    this.setState({
      infoData: infoData,
    });
  };

  redirectToMyControlActive = () => {
    this.props.history.push("/my_controls/active");
  };

  onDeleteButtonClick = () => {
    this.showPopup(
      "Komunikat",
      this.state.infoData.isFinalInfo
        ? PropertyBucket.deletePostControlFinalInfoConfirmationMessage()
        : PropertyBucket.deletePostControlInfoConfirmationMessage(),
      "confirm",
      () => {
        this.handleDeleteInfo();
      }
    );
  };

  handleDeleteInfo = () => {
    this.isWaitingOnOff(true);
    let url = PropertyBucket.getDeletePostControlDocument(
      this.controlId,
      this.state.postControlDocumentId
    );
    let callPromise = httpService.getService(url, "DELETE", null);
    let _this = this;

    callPromise.then(
      function (message) {
        _this.isWaitingOnOff(false);
        _this.showPopup(
          "Komunikat",
          _this.state.infoData.isFinalInfo
            ? PropertyBucket.deletePostControlFinalInfoMessage()
            : PropertyBucket.deletePostControlInfoMessage(),
          "notify",
          () => {
            _this.redirectToMyControlActive();
          }
        );
      },
      function (error) {
        _this.isWaitingOnOff(false);
        _this.showPopup("Błąd", error.message ? error.message : error, "error");
      }
    );
  };

  handleSaveValidationStatus = () => {
    let _this = this;

    _this.isWaitingOnOff(true);
    let url = PropertyBucket.getPostControlInfoValidationStatusSave(
      this.infoId
    );
    let callPromise = httpService.getServicePromise(url, "PUT");

    callPromise.then(
      function () {
        _this.isWaitingOnOff(false);
        _this.showPopup(
          "Komunikat",
          _this.state.infoData.isFinalInfo
            ? PropertyBucket.postControlFinalInfoValidatedMessage()
            : PropertyBucket.postControlInfoValidatedMessage()
        );
        _this.fetchInfoData(_this.infoId);
      },
      function (error) {
        _this.isWaitingOnOff(false);
        _this.showPopup("Błąd", error.message ? error.message : error, "error");
      }
    );
  };

  handleValidateInfo = (info, abbrevs, findings) => {
    if (
      this.handleValidateAbbrevs(abbrevs) &&
      this.handleValidateInfoDataNotEmpty(info.legalBasis) &&
      this.handleValidateInfoDataNotEmpty(info.controlPurpose) &&
      this.handleValidateInfoDataNotEmpty(info.controlSubject) &&
      this.handleValidateInfoDataNotEmpty(info.controlSummary) &&
      this.handleValidateInfoDataNotEmpty(info.finalInstructions) &&
      this.handleValidateRecommendations(findings) &&
      this.handleValidateFindings(findings) &&
      this.handleValidateFindingCorrections(findings)
    ) {
      this.handleSaveValidationStatus();
    } else {
      let validationMessage = "";
      this.handleValidateAbbrevs(abbrevs) === false
        ? (validationMessage +=
            "Wykaz skrótów przekracza maksymalną długość 8000 znaków \n")
        : null;
      this.handleValidateInfoDataNotEmpty(info.legalBasis) === false
        ? (validationMessage += "Uzupełnij podstawę prawną kontroli \n")
        : null;
      this.handleValidateInfoDataNotEmpty(info.controlPurpose) === false
        ? (validationMessage += "Uzupełnij cel kontroli \n")
        : null;
      this.handleValidateInfoDataNotEmpty(info.controlSubject) === false
        ? (validationMessage += "Uzupełnij przedmiot kontroli \n")
        : null;
      this.handleValidateInfoDataNotEmpty(info.controlSummary) === false
        ? (validationMessage += "Uzupełnij podsumowanie kontroli \n")
        : null;
      this.handleValidateInfoDataNotEmpty(info.finalInstructions) === false
        ? (validationMessage += "Uzupełnij pouczenie końcowe \n")
        : null;
      this.handleValidateFindings(findings) === false
        ? (validationMessage += "Uzupełnij wszystkie pola ustalenia \n")
        : null;
      this.handleValidateRecommendations(findings) === false
        ? (validationMessage += "Uzupełnij zalecenie \n")
        : null;
      this.handleValidateFindingCorrections(findings) === false
        ? (validationMessage +=
            "Ustalenie finansowe musi mieć przynajmniej jedną korektę \n")
        : null;

      // TODO: add validation to single fields
      // if (this.handleValidateInfoDataNotEmpty(info.finalInstructions) === false) {
      // 	this.setState({isEmptyField: true})
      // }

      this.showPopup("Błąd", validationMessage, "error");
    }
  };

  handleValidateInfoDataNotEmpty = (value) => {
    return value !== "" && value !== null;
  };

  isDraftJsContent = (value) => {
    if (typeof value !== 'string') return false;
    try {
      const parsed = JSON.parse(value);
      return (
        parsed &&
        typeof parsed === 'object' &&
        Array.isArray(parsed.blocks) &&
        typeof parsed.entityMap === 'object'
      );
    } catch {
      return false;
    }
  };

  handleValidateAbbrevs = (abbrevs) => {
    if (!abbrevs) return true;
    let text = '';
    if (this.isDraftJsContent(abbrevs)) {
      const contentState = convertFromRaw(JSON.parse(abbrevs));
      text = contentState.getPlainText();
    } else {
      text = abbrevs;
    }
    return text.length <= 8000;
  };

  handleValidateFindings = (findings) => {
    let validated = true;
    findings.forEach((finding) => {
      if (finding.title === "" || finding.content === "") {
        validated = false;
      }

      if (finding.isFinancial === true && finding.findingKind == null) {
        validated = false;
      }
    });
    return validated;
  };

  handleValidateRecommendations = (findings) => {
    let validated = true;
    findings.forEach((finding) => {
      finding.recommendations.forEach((recommendation) => {
        if (recommendation.recommendationText === "") {
          validated = false;
        }
      });
    });
    return validated;
  };

  handleValidateFindingCorrections = (findings) => {
    let validated = true;
    findings.forEach((finding) => {
      if (
        finding.isFinancial === true &&
        finding.corrections.filter((x) => !x.toRemove).length === 0
      ) {
        validated = false;
      }
    });
    return validated;
  };

  isWaitingOnOff = (OnOff) => {
    this.setState({
      isWaiting: OnOff,
    });
  };

  printWysiwygEditor = (
    label,
    name,
    value,
    onChange,
    size,
    validateFn,
    validateError
  ) => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <button
          className="btn save-btn"
          style={{ width: "fit-content", marginLeft: "auto" }}
          disabled={!this.isSectionEdit(null)}
          onClick={() => {
            var infoDataClone = cloneDeep(this.state.infoData[name]);

            this.setState({
              sectionUnderEdit: name,
              originalInfoData: infoDataClone,
            });
          }}
        >
          EDYTUJ
        </button>
        <WysiwygEditor
          name={name}
          label={label}
          size={size}
          value={value}
          onChange={onChange}
          readOnly={!this.isSectionEdit(name)}
        />
        <div className="btn_group">
          <button
            className="btn save-btn"
            disabled={!this.isSectionEdit(name)}
            onClick={() => {
              if (!validateFn()) {
                this.showPopup("Błąd", validateError, "error");
                return;
              }

              this.setState({
                sectionUnderEdit: null,
                originalInfoData: null,
              });

              this.isWaitingOnOff(true);

              const url = this.getSectionUrl(name);

              let sectionJson = {
                [name]: this.state.infoData[name],
              };

              let callPromise = httpService.getServicePromise(
                url,
                "POST",
                sectionJson
              );
              let _this = this;

              callPromise.then(
                function () {
                  _this.isWaitingOnOff(false);
                  _this.showPopup(
                    "Komunikat",
                    `Poprawnie zapisano sekcję ${label}`
                  );

                  _this.setState({
                    infoData: {
                      ..._this.state.infoData,
                      isValidated: false,
                    },
                  });
                  _this.fetchInfoData(_this.infoId);
                },
                function (error) {
                  _this.isWaitingOnOff(false);
                  _this.showPopup(
                    "Błąd",
                    error.message ? error.message : error,
                    "error"
                  );
                }
              );
            }}
          >
            ZAPISZ
          </button>
          {this.isSectionEdit(name) && (
            <button
              className="btn cancel-btn"
              onClick={() => {
                var infoData = { ...this.state.infoData };
                infoData[name] = this.state.originalInfoData;

                this.setState({
                  sectionUnderEdit: null,
                  infoData: infoData,
                });
              }}
            >
              ANULUJ
            </button>
          )}
        </div>
      </div>
    );
  };

  printContent = (control) => {
    const fileNameForPdf = `eKontrole-${this.infoNumber}.pdf`;
    let infoData = this.state.infoData;
    let abbrevs = this.state.abbrevs;
    let findings = this.state.findings;
    const projectNumbers = [control.project.metadata.businessId, ...control.otherControlledProjectNumbers]
    document.title = `e-Kontrole | ${
      this.state.infoData.isFinalInfo ? "Ostateczna i" : "I"
    }nformacja pokontrolna nr: ${this.infoNumber || ""}, numer kontroli: ${
      control.number
    }`;
    return (
      <div>
        <button
          type="button"
          onClick={this.generateDocs}
          className="doc-button"
        >
          <img
            className="ico-doc"
            src="/icoDoc.svg"
            alt="Pobierz dokument .docx"
          />
        </button>
        {isWTrakcieRealizacji(control) && infoData.isValidated && (
          <button
            className="btn success-btn"
            id="pdf_img_container"
            onClick={() => {
              sendLog(null, null, fileNameForPdf);
            }}
          >
            <span className="sr-only">Pobierz PDF</span>
            <PDFDownloadLink
              document={createPdf(
                false,
                {
                  ...this.state,
                  infoData: { ...infoData, findings: this.state.findings },
                },
                this.infoNumber,
                this.state.checklistVersion
              )}
              fileName={fileNameForPdf}
            >
              {({ loading }) =>
                loading ? (
                  ""
                ) : (
                  <>
                    <PictureAsPdfIcon
                      style={{ color: "#0d47a1", fontSize: 46 }}
                    />
                    <span className="sr-only">Kliknij, aby pobrać PDF</span>
                  </>
                )
              }
            </PDFDownloadLink>
          </button>
        )}
        {isWTrakcieRealizacji(control) && !infoData.isValidated && (
          <span className="red h5">WERSJA ROBOCZA</span>
        )}

        <div
          className="btn_group my-1"
          style={{
            display: "inline-block",
            float: "right",
            width: "50%",
          }}
        >
          <button
            className="btn save-btn"
            onClick={() => this.handleValidateInfo(infoData, abbrevs, findings)}
            disabled={!this.isSectionEdit(null)}
          >
            SPRAWDŹ
            <span className="sr-only">
              {" "}
              poprawność wypełnienia danych do informacji pokontrolnej nr{" "}
              {this.infoNumber}
            </span>
          </button>
          <button className="btn cancel-btn" onClick={this.onDeleteButtonClick}>
            USUŃ
            <span className="sr-only">
              {" "}
              informację pokontrolną nr {this.infoNumber}
            </span>
          </button>
        </div>
        <br />
        <br />
        <br />
        <h3 align="center">
          <span className="titleClass">
            {this.state.infoData.isFinalInfo ? "OSTATECZNA " : ""}INFORMACJA
            POKONTROLNA nr
          </span>
          &nbsp;
          <span>{this.infoNumber}</span>
          <br />
          <span className="titleClass">Numer kontroli</span>
          <span>{control.number}</span>
        </h3>

        <div className="framed-part framed-part--first">
          <h4 className="framed-part__title">Informacje wstępne</h4>
          <button
            className="btn save-btn"
            style={{ float: "right" }}
            disabled={!this.isSectionEdit(null)}
            onClick={() => {
              this.setState({
                sectionUnderEdit: "controlInfo",
                originalChecklistVersion: cloneDeep(
                  this.state.checklistVersion
                ),
              });
            }}
          >
            EDYTUJ
          </button>
          <ControlDetailInfo
            control={control}
            checklistVersion={this.state.checklistVersion}
            handleChangeChecklistVersion={(checklistVersion) =>
              this.setState({
                checklistVersion: checklistVersion,
              })
            }
            isSectionEdit={(value) => this.isSectionEdit(value)}
          />

          <div className="btn_group" style={{ padding: "0px 15px" }}>
            <button
              className="btn save-btn"
              disabled={!this.isSectionEdit("controlInfo")}
              onClick={() => {
                if (
                  !this.handleValidateInfoDataNotEmpty(
                    this.state.checklistVersion
                  )
                ) {
                  this.showPopup(
                    "Błąd",
                    "Wersja listy sprawdzającej nie może być pusta.",
                    "error"
                  );
                  return;
                }

                this.setState({ sectionUnderEdit: null });

                this.isWaitingOnOff(true);

                const url = PropertyBucket.setChecklistVersion(this.infoId);

                const payload = {
                  checklistVersion: this.state.checklistVersion,
                };

                const callPromise = httpService.getServicePromise(
                  url,
                  "POST",
                  payload
                );

                callPromise.then(
                  () => {
                    this.isWaitingOnOff(false);
                    this.showPopup(
                      "Komunikat",
                      "Poprawnie zapisano sekcję Informacje wstępne"
                    );
                    this.setState({
                      infoData: {
                        ...this.state.infoData,
                        isValidated: false,
                      },
                    });
                    this.fetchInfoData(this.infoId);
                  },
                  (error) => {
                    this.isWaitingOnOff(false);
                    this.showPopup("Błąd", error.message || error, "error");
                  }
                );
              }}
            >
              ZAPISZ<span className="sr-only"> informacje wstępne</span>
            </button>
            {this.isSectionEdit("controlInfo") && (
              <button
                className="btn cancel-btn"
                onClick={() => {
                  this.setState({
                    sectionUnderEdit: null,
                    checklistVersion: this.state.originalChecklistVersion,
                    originalChecklistVersion: null,
                  });
                }}
              >
                ANULUJ
              </button>
            )}
          </div>
        </div>

        <div className="framed-part">
          <h4 className="framed-part__title">1. Wykaz skrótów</h4>
          {abbrevs != null ? this.renderAbbreviations() : null}
        </div>

        <div className="framed-part">
          <h4 className="framed-part__title">2. Podstawa prawna</h4>
          {this.printWysiwygEditor(
            "Podstawa prawna",
            "legalBasis",
            infoData.legalBasis === null ? "" : infoData.legalBasis,
            this.handleChange,
            8000,
            () => this.handleValidateInfoDataNotEmpty(infoData.legalBasis),
            "Uzupełnij podstawę prawną kontroli"
          )}
        </div>

        <div className="framed-part">
          <h4 className="framed-part__title">3. Cel kontroli</h4>
          {this.printWysiwygEditor(
            "Cel kontroli",
            "controlPurpose",
            infoData.controlPurpose === null ? "" : infoData.controlPurpose,
            this.handleChange,
            8000,
            () => this.handleValidateInfoDataNotEmpty(infoData.controlPurpose),
            "Uzupełnij cel kontroli"
          )}
        </div>

        <div className="framed-part">
          <h4 className="framed-part__title">4. Przedmiot kontroli</h4>
          {this.printWysiwygEditor(
            "Przedmiot kontroli",
            "controlSubject",
            infoData.controlSubject === null ? "" : infoData.controlSubject,
            this.handleChange,
            8000,
            () => this.handleValidateInfoDataNotEmpty(infoData.controlSubject),
            "Uzupełnij przedmiot kontroli"
          )}
        </div>

        <div className="framed-part">
          <h4 className="framed-part__title">
            5. Ustalenia i zalecenia pokontrolne
          </h4>
          {this.renderBlocks(findings)}
        </div>

        <div className="framed-part">
          <h4 className="framed-part__title">
            6. Podsumowanie ustaleń finansowych
          </h4>
          {findings && findings.length > 0 ? (
            this.renderFinancialCorrections(
              projectNumbers,
              this.filterFinancialFindings(findings),
              control.orders,
              control.paymentClaims
            )
          ) : (
            <p>Brak ustaleń finansowych</p>
          )}
        </div>

        <div className="framed-part">
          <h4 className="framed-part__title">7. Podsumowanie kontroli</h4>
          {this.printWysiwygEditor(
            "Podsumowanie kontroli",
            "controlSummary",
            infoData.controlSummary === null ? "" : infoData.controlSummary,
            this.handleChange,
            8000,
            () => this.handleValidateInfoDataNotEmpty(infoData.controlSummary),
            "Uzupełnij podsumowanie kontroli"
          )}
        </div>

        <div className="framed-part">
          <h4 className="framed-part__title">8. Pouczenie końcowe</h4>
          {this.printWysiwygEditor(
            "Pouczenie końcowe",
            "finalInstructions",
            infoData.finalInstructions === null
              ? ""
              : infoData.finalInstructions,
            this.handleChange,
            8000,
            () =>
              this.handleValidateInfoDataNotEmpty(infoData.finalInstructions),
            "Uzupełnij pouczenie końcowe"
          )}
        </div>

        <div className="framed-part">
          <h4 className="framed-part__title">9. Załączniki</h4>

          <CreatePostControlInfoAttachments
            attachments={this.state.attachments}
            controlUuid={this.state.controlData.uuid}
            projectUuid={this.state.controlData.project.metadata.uuid}
            isSectionEdit={(value) => this.isSectionEdit(value)}
            setAttachments={(attachments) =>
              this.setState({
                attachments,
              })
            }
            handleEdit={() => {
              this.setState({
                sectionUnderEdit: "attachments",
                originalAttachments: cloneDeep(this.state.attachments),
              });
            }}
          />

          <div className="btn_group">
            <button
              className="btn save-btn"
              disabled={!this.isSectionEdit("attachments")}
              onClick={() => {
                this.setState({
                  sectionUnderEdit: null,
                  originalAttachments: [],
                });
                this.isWaitingOnOff(true);
                const url = PropertyBucket.setAttachments(this.infoId);

                let payload = serializeAttachmentsForPostControlInfoSaving(
                  this.state.attachments,
                  true
                );

                let callPromise = httpService.getServicePromise(
                  url,
                  "PUT",
                  payload
                );

                let _this = this;

                callPromise.then(
                  function () {
                    _this.isWaitingOnOff(false);
                    _this.showPopup(
                      "Komunikat",
                      `Poprawnie zapisano sekcję Załączniki`
                    );
                    _this.setState({
                      infoData: {
                        ..._this.state.infoData,
                        isValidated: false,
                      },
                    });
                    _this.fetchInfoData(_this.infoId);
                  },
                  function (error) {
                    _this.isWaitingOnOff(false);
                    _this.showPopup(
                      "Błąd",
                      error.message ? error.message : error,
                      "error"
                    );
                  }
                );
              }}
            >
              ZAPISZ<span className="sr-only"> załączniki</span>
            </button>
            {this.isSectionEdit("attachments") && (
              <button
                className="btn cancel-btn"
                onClick={() => {
                  this.setState({
                    sectionUnderEdit: null,
                    attachments: this.state.originalAttachments,
                    originalAttachments: [],
                  });
                }}
              >
                ANULUJ
              </button>
            )}
          </div>
        </div>

        <div className="row">
          <div className="btn_group-left mb-5 col-md-6">
            <button
              className="btn save-btn"
              onClick={() =>
                this.handleValidateInfo(infoData, abbrevs, findings)
              }
              disabled={!this.isSectionEdit(null)}
            >
              SPRAWDŹ
              <span className="sr-only">
                {" "}
                poprawność wypełnienia danych do informacji pokontrolnej nr{" "}
                {this.infoNumber}
              </span>
            </button>
            <button
              className="btn cancel-btn"
              onClick={this.onDeleteButtonClick}
            >
              USUŃ
              <span className="sr-only">
                {" "}
                informację pokontrolną nr {this.infoNumber}
              </span>
            </button>
          </div>

          <div className="btn_group mb-5 col-md-6">
            <button
              className="btn cancel-btn"
              onClick={() =>
                this.props.history.push(
                  `/my_controls/active?number=${this.state.controlData.number}`
                )
              }
            >
              ANULUJ
              <span className="sr-only"> uzupełnianie formularza</span>
            </button>
          </div>
        </div>

        <div style={{ borderTop: "2px solid" }}>
          <h4 className="mt-4">Dane audytowe:</h4>
          {
            <AuditDetail
              auditData={{
                createdOn: infoData?.dataCreatedOn,
                createdByLogin: infoData?.dataCreatedByLogin,
                createdBy: infoData?.dataCreatedBy,
                updatedOn: infoData?.dataUpdatedOn,
                updatedByLogin: infoData?.dataUpdatedByLogin,
                updatedBy: infoData?.dataUpdatedBy,
              }}
            ></AuditDetail>
          }
        </div>
      </div>
    );
  };

  generateDocs = () => {
    this.state.infoData.findings = this.state.findings;
    generatePostControllInfoDocx(this.state.controlData, this.state.infoData, this.state.checklistVersion);
  };


  renderAbbreviations = () => {
    const { abbrevs } = this.state;
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <button
          className="btn save-btn"
          style={{ width: "fit-content", marginLeft: "auto" }}
          disabled={!this.isSectionEdit(null)}
          onClick={() => {
            this.setState({
              sectionUnderEdit: "abbrevs",
              originalAbbrevs: this.state.abbrevs,
            });
          }}
        >
          EDYTUJ
        </button>
        <WysiwygEditor
          name="abbrevs"
          label="Wykaz skrótów"
          size={8000}
          value={abbrevs}
          onChange={(e) => {
            this.setState({ abbrevs: e.target.value });
          }}
          readOnly={!this.isSectionEdit("abbrevs")}
        />
        <div className="btn_group">
          <button
            className="btn save-btn"
            disabled={!this.isSectionEdit("abbrevs")}
            onClick={() => {
              if (!this.handleValidateAbbrevs(abbrevs)) {
                this.showPopup(
                  "Błąd",
                  "Wykaz skrótów przekracza maksymalną długość 8000 znaków",
                  "error"
                );
                return;
              }

              this.setState({
                sectionUnderEdit: null,
                originalAbbrevs: "",
              });

              this.isWaitingOnOff(true);

              const url = PropertyBucket.setAbbrevs(this.infoId);

              const abbreviationsPlainText = draftjsToString(this.state.abbrevs);

              let sectionJson = {
                abbreviations: abbreviationsPlainText,
              };

              let callPromise = httpService.getServicePromise(
                url,
                "POST",
                sectionJson
              );
              let _this = this;

              callPromise.then(
                function () {
                  _this.isWaitingOnOff(false);
                  _this.showPopup(
                    "Komunikat",
                    `Poprawnie zapisano sekcję Wykaz skrótów`
                  );
                  _this.setState({
                    infoData: {
                      ..._this.state.infoData,
                      isValidated: false,
                    },
                  });
                  _this.fetchInfoData(_this.infoId);
                },
                function (error) {
                  _this.isWaitingOnOff(false);
                  _this.showPopup(
                    "Błąd",
                    error.message ? error.message : error,
                    "error"
                  );
                }
              );
            }}
          >
            ZAPISZ<span className="sr-only"> wykaz skrótów</span>
          </button>
          {this.isSectionEdit("abbrevs") && (
            <button
              className="btn cancel-btn"
              onClick={() => {
                this.setState({
                  sectionUnderEdit: null,
                  abbrevs: this.state.originalAbbrevs,
                });
              }}
            >
              ANULUJ
            </button>
          )}
        </div>
      </div>
    );
  };


  // obsługa ustaleń i zaleceń
  renderBlocks(findings) {
    const CHAPTER = "5.";
    let counter = 0;
    const uniqueBlocks = getUniqueBlocks(findings);
    return (
      <>
        <div key="noBlocks">
          <button
            className="btn save-btn"
            id="plus_img_container"
            disabled={
              this.state.findingUnderEdit !== null ||
              this.state.sectionUnderEdit !== null
            }
            onClick={() => this.addBlockWithOneEmptyFinding(uniqueBlocks)}
          >
            <i
              aria-hidden="true"
              className="v-icon material-icons theme--light v-list-text"
            >
              add
            </i>
            <span>DODAJ BLOK</span>
          </button>
          <div className="clearfix mb-3" />
        </div>
        {uniqueBlocks.map((block) => {
          counter += 1;
          return (
            <div key={block.id} className="finding-container">
              <h4 className="my-4">{`${CHAPTER}${counter} ${block.name}`}</h4>
              {this.renderFindings(findings, block.name, counter, block.id)}
              <button
                className="btn save-btn add-finding-btn"
                disabled={
                  this.state.findingUnderEdit !== null ||
                  this.state.sectionUnderEdit !== null
                }
                onClick={() => this.addFinding(block.id, block.name)}
              >
                DODAJ USTALENIE
                <span className="sr-only">
                  do {CHAPTER}
                  {counter} {block.name}
                </span>
              </button>
            </div>
          );
        })}
      </>
    );
  }

  addFinding = (blockId, blockName) => {
    let findingDto = new FindingDto();
    findingDto.pseudoId = Date.now();
    let blockInListDto = new BlockInListDto();
    blockInListDto.id = blockId;
    blockInListDto.name = blockName;
    findingDto.blockInList = blockInListDto;

    let findings = [...this.state.findings, findingDto];

    const findingKey = `findingIndex_${findingDto.id}_${findingDto.pseudoId}`;

    this.setState({
      findings: findings,
      findingInputautofocus: true,
      findingUnderEdit: findingKey,
    });
  };

  addBlockWithOneEmptyFinding = (alreadyAddedBlocks) => {
    const mapBlocksInListToRawBlock = (blocksInList) => {
      return blocksInList.map((blockInList) => {
        return {
          blockId: blockInList.id,
          name: blockInList.name,
          active: blockInList.active,
          creationPerson: blockInList.audit.createdBy,
          creationDate: blockInList.audit.createdOn,
          modificationPerson: blockInList.audit.updatedBy,
          modificationDate: blockInList.audit.updatedOn,
          questionList: blockInList.questionsInBlock,
        };
      });
    };

    this.setState({ chosenBlockToCreateNewFinding: null });
    this.showPopup(
      "Wybierz blok",
      <ChooseBlock
        blocks={mapBlocksInListToRawBlock(
          this.state.controlData.questionList.blocksInList
        )}
        disabledBlocks={alreadyAddedBlocks}
        onChange={(block) =>
          this.setState({ chosenBlockToCreateNewFinding: block })
        }
      />,
      "confirm",
      () => {
        const block = this.state.chosenBlockToCreateNewFinding;
        if (block) {
          this.addFinding(block.blockId, block.name);
        }
      }
    );
  };


  filterFinancialFindings = (findings) => {
    return findings.filter(
      (finding) => finding.isFinancial === true && finding.findingKind !== null
    );
  };

  numberFindingsForBlock = (findings, blockNumber) => {
    if (!Array.isArray(findings)) return [];
    findings.sort((a, b) => a.id - b.id);
    findings.forEach((f, idx) => { f.number = `${blockNumber}.${idx + 1}` });
    return findings;
  };

  renderFindings = (findings, blockName, blockNumber, blockId) => {
    let findingsRows = []; // 'bloki' do wyrenderowania w komponencie podrzędnym

    const findingsForBlock = findings.filter(f => f.blockInList.id === blockId);

    this.numberFindingsForBlock(findingsForBlock, blockNumber);

    const loadedFindingKindsData = store.getState().findingKinds.findingKinds;

    findingsRows.push(
      <CreatePostControlInfoFindings
        key={blockName}
        blockName={blockName}
        blockNumber={blockNumber}
        blockId={blockId}
        findings={findingsForBlock}
        findingKinds={loadedFindingKindsData}
        onFindingsChange={this.handleFindingsRefresh}
        findingInputautofocus={this.state.findingInputautofocus}
        findingUnderEdit={this.state.findingUnderEdit}
        sectionUnderEdit={this.state.sectionUnderEdit}
        makeFindingCopy={(finding) => {
          this.setState({
            originalFinding: cloneDeep(finding),
          });
        }}
        restoreFinding={() => {
          this.setState({
            findings: this.state.findings.map((finding) =>
              finding.id === this.state.originalFinding.id
                ? this.state.originalFinding
                : finding
            ),
          });
        }}
        setFindingUnderEdit={(value) => {
          this.setState({
            findingUnderEdit: value,
          });
        }}
        saveFinding={(findingId, findingPseudoId) =>
          this.handleSaveFinding(findingId, findingPseudoId)
        }
        deleteFinding={(findingId) => this.handleDeleteFinding(findingId)}
      />
    );

    return findingsRows;
  };

  renderFinancialCorrections = (projectNumbers, findings, orders, paymentClaims) => {
    return (
      <>
        <CreatePostControlInfoCorrections
          projectNumbers={projectNumbers}
          findings={findings}
          orders={orders}
          paymentClaims={paymentClaims}
          onCorrectionsChange={this.handleAllFindingsRefresh}
          isWaitingOnOff={this.isWaitingOnOff}
          isSectionEdit={(value) => this.isSectionEdit(value)}
          makeFindingsCopy={() => {
            this.setState({
              originalFindings: cloneDeep(this.state.findings),
              originalFinancialFindingsNotes: this.state.financialFindingsNotes,
            });
          }}
          restoreFindings={() => {
            this.setState({
              originalFindings: [],
              findings: this.state.originalFindings,
              financialFindingsNotes: this.state.originalFinancialFindingsNotes,
            });
          }}
          setSectionEdit={(value) => {
            this.setState({ sectionUnderEdit: value });
          }}
          financialFindingsNotes={() => (
            <WysiwygEditor
              name="financialFindingsNotes"
              label="Uwagi do ustaleń finansowych"
              size={8000}
              value={this.state.financialFindingsNotes}
              onChange={(e) => {
                this.setState({ financialFindingsNotes: e.target.value });
              }}
              readOnly={!this.isSectionEdit("corrections")}
            />
          )}
          saveCorrections={() => {
            this.setState({ sectionUnderEdit: null });

            this.isWaitingOnOff(true);

            const url = PropertyBucket.setCorrections(this.infoId);

            const payload = {
              corrections: this.state.findings.flatMap((finding) =>
                finding.corrections.map((correction) => {
                  const { order, paymentClaim, ...rest } = correction;

                  return {
                    findingId: finding.id,
                    paymentClaimId: paymentClaim?.id ?? null,
                    orderId: order?.id ?? null,
                    ...rest,
                  };
                })
              ),
              financialFindingsNotes: this.state.financialFindingsNotes,
            };

            const callPromise = httpService.getServicePromise(
              url,
              "PUT",
              payload,
              true
            );

            callPromise.then(
              (response) => {
                this.setState({
                  findings: this.state.findings.map((finding) => {
                    const updatedCorrections = finding.corrections.map(
                      (correction) => {
                        const foundCorrection = response.find(
                          (x) => x.pseudoId === correction.pseudoId
                        );
                        return {
                          ...correction,
                          id: foundCorrection
                            ? foundCorrection.id
                            : correction.id,
                        };
                      }
                    );

                    return {
                      ...finding,
                      corrections: updatedCorrections,
                    };
                  }),
                });

                this.isWaitingOnOff(false);
                this.showPopup(
                  "Komunikat",
                  "Poprawnie zapisano sekcję Podsumowanie ustaleń finansowych"
                );
                this.setState({
                  infoData: {
                    ...this.state.infoData,
                    isValidated: false,
                  },
                });
                this.fetchInfoData(this.infoId);
              },
              async (error) => {
                  let data;
                  try {
                    data = await error.json();
                  } catch {
                    data = { message: error.message || "Nieznany błąd" };
                  }
                  this.isWaitingOnOff(false);
                  this.showPopup("Błąd", data.message, "error");
                }
            );
          }}
        />
      </>
    );
  };

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    let control = this.state.controlData;
    if (this.state.controlData && this.state.infoData) {
      let isFinal = this.state.infoData.isFinalInfo;
      let infoSuffix = isFinal ? "-OST" : "-INF";
      this.infoNumber = this.state.controlData.number + infoSuffix;
    }
    let popUp;
    this.state.showPopup
      ? (popUp = (
          <PopUp
            type={this.state.popUp.type}
            title={this.state.popUp.title}
            notification={this.state.popUp.notification}
            link={this.state.popUp.link ? this.state.popUp.link : null}
            onClickEvent={this.state.popUp.onClickEvent}
            closePopUp={this.handleClosePopUp}
          />
        ))
      : null;

    return (
      <>
        {this.state.isPreventPromptEnabled && (
          <Prompt
            when={!this.state.isChangeRoutePossible}
            message={this.preventChangeRoute}
          />
        )}
        <div id="post-control-info">
          {popUp}
          {control ? (
            this.printContent(control)
          ) : (
            <button
              className="btn save-btn"
              id="plus_img_container"
              onClick={this.goBack}
            >
              <i
                data-v-db6946bc=""
                aria-hidden="true"
                className="v-icon material-icons theme--light v-list-text"
              >
                arrow_back
              </i>
              <span>WRÓĆ</span>
            </button>
          )}
          <div id="waiter">
            <Waiter loading={this.state.isWaiting} />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchControlData: (url) => dispatch(actions.getControlData(url)),
    fetchFindingKindsData: () =>
      dispatch(actionsFindingKinds.getFindingKindsData()),
  };
};

export const CreatePostControlInfoProvider = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePostControlInfo);
